import React from 'react';

const ToggleViewButton = ({ viewMode, setViewMode }) => {
  const isMapView = viewMode === 'map';
  
  const handleToggle = () => {
    setViewMode(isMapView ? 'list' : 'map');
  };

  return (
    <div className="toggle-container" >
      <div className={`toggle-track ${viewMode === 'list' ? 'list-view' : ''}`} onClick={handleToggle}>
        <div className={`option map ${viewMode === 'map' ? 'active' : ''}`}>
          <i className="fas fa-map-marker-alt"></i> Channel Map
        </div>
        <div className={`option list ${viewMode === 'list' ? 'active' : ''}`}>
          <i className="fas fa-list"></i> Channel List
        </div>
        <div className="slider"></div>
      </div>
    </div>
  );  
};

export default ToggleViewButton;
